/* TOPPAN SVテスト環境設定 */
export const environment = {
  production: false,

  // (仮ドメイン)
  apiURL: 'https://coopdeli.api.sv.next-peace-td.click/N_PEACE/',
  imageURL: '',
  version: '0.0.1',

  // 現行バックエンドに秘密裏にログイン
  loginToCurrentBackend: false,

  // 機能メニュー自動クローズ
  fmenuAutoClose: true
};